import { useEffect } from 'react'
import { Flex, Spinner } from '@nilohealth/core-ui'
import { useRouter } from 'next/router'

import { useAuth, useNiloId } from '@auth/auth.hooks'
import { usePermissionContext } from '@permissions/permissions.hooks'
import { PermissionsActions, PermissionsResources } from '@permissions/permissions.types'

type WithAuthRestrictedProps = {
  action: PermissionsActions
  resource: PermissionsResources
}
const withAuth = <P extends {}>(Component: React.ComponentType<P>, restricted?: WithAuthRestrictedProps) => {
  return (props: P) => {
    const router = useRouter()
    const permission = usePermissionContext()
    const { redirectToLogin } = useNiloId()

    const { isLoading, isAuthorised, isSignOut } = useAuth()

    useEffect(() => {
      if (!isLoading && !isAuthorised && !isSignOut) {
        redirectToLogin({ from: router.asPath })        
      }

      if (
        isAuthorised &&
        restricted &&
        !permission.isLoading &&
        !permission.isAllowedTo(restricted.resource, restricted.action)
      ) {
        router.push('/accessdenied')
      }
    }, [isLoading, isAuthorised, permission])

    if (!isAuthorised || (restricted && !permission.isAllowedTo(restricted.resource, restricted.action))) {
      return (
        <Flex align="center" justify="center" css={{ flex: 1, width: '100vw', height: '100vh' }}>
          <Spinner size="large" />
        </Flex>
      )
    }
    return <Component {...props} />
  }
}

export default withAuth
